import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { KeyRound } from 'lucide-react';
import { Toaster } from '../components/ui/sonner';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [pwd, setPwd] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) { toast.error('La password deve avere almeno 8 caratteri'); return; }
    if (pwd !== pwd2) { toast.error('Le password non coincidono'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: pwd }),
      });
      const data = await res.json();
      if (res.ok) {
        toast.success('Password reimpostata! Ora puoi accedere.');
        setTimeout(() => navigate('/admin/avvisi'), 1500);
      } else {
        toast.error(typeof data.detail === 'string' ? data.detail : 'Errore');
      }
    } catch {
      toast.error('Errore di connessione. Riprova.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1B2380] to-[#0E8C84] flex items-center justify-center px-4 py-12">
      <Toaster position="top-right" richColors />
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-xl bg-[#1B2380]/10 flex items-center justify-center">
            <KeyRound size={22} className="text-[#1B2380]" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-800">Nuova password</h1>
            <p className="text-sm text-gray-500">Pannello Admin Assietica</p>
          </div>
        </div>
        {!token ? (
          <p className="text-sm text-gray-600">Link non valido: apri il collegamento ricevuto via email.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="reset-pwd-input" type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1B2380]" placeholder="Nuova password (min 8 caratteri)" required />
            <input data-testid="reset-pwd2-input" type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1B2380]" placeholder="Conferma nuova password" required />
            <button data-testid="reset-submit-btn" type="submit" disabled={loading} className="w-full bg-[#1B2380] hover:bg-[#2A3299] text-white font-semibold py-2.5 rounded-lg transition-colors duration-300 disabled:opacity-60">
              {loading ? 'Salvataggio...' : 'Imposta nuova password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
